import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { QueryVariables, StaleTime } from 'queries/types';

import { ticketsEventIdByDatoEventSlugQuery } from './queries';

export const useTicketsIdByDatoEventSlug = (
  variables: QueryVariables<typeof ticketsEventIdByDatoEventSlugQuery>,
) => {
  const { locale } = useLocale();

  const { data } = useQuery({
    ...ticketsEventIdByDatoEventSlugQuery({ locale, ...variables }),
    staleTime: StaleTime.FOREVER,
    enabled: !!variables.slug,
  });

  return {
    ticketsEventId: data?.pageEvent?.ticketsEventId ?? '',
    ticketsTimeslotId: data?.pageEvent?.ticketsTimeslotId ?? '',
  };
};
